import { render } from "./DataDemandSide.vue?vue&type=template&id=bf1f8972&scoped=true"
import script from "./DataDemandSide.vue?vue&type=script&lang=js"
export * from "./DataDemandSide.vue?vue&type=script&lang=js"

import "./DataDemandSide.vue?vue&type=style&index=0&id=bf1f8972&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1f8972"]])

export default __exports__